/** Compact display labels only. Keep raw sizes for facet values and API requests. */
export function formatProductSize(value: string | null | undefined): string {
  return (value || '').trim().replace(
    /(\d+(?:\.\d+)?)\s*(milligrams?|mgs?|grams?|gms?|g)\b/gi,
    (_, amount: string, unit: string) => `${amount}${/^m/i.test(unit) ? 'MG' : 'G'}`,
  );
}
